import { Card, CardContent, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  card: {
    borderRadius: 16,
    width: "100%",
    padding: 20,
  },
}));

type CardItemAuthorizationProps = {
  children?: React.ReactNode;
};

export const CardCustom = ({ children }: CardItemAuthorizationProps) => {
  const classes = useStyles();
  return (
    <Card variant="outlined" className={classes.card}>
      <CardContent>
        <div className={classes.paper}>{children}</div>
      </CardContent>
    </Card>
  );
};
